import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

const Boom = () => (
<div className="col-12 col-md-12 p-3 text-center"
style={{
backgroundRepeat: 'no-repeat',
backgroundAttachment: 'fixed',
backgroundPosition: 'center', 
backgroundSize: 'cover',
backgroundImage: `url(${('https://1.bp.blogspot.com/-0kSVnP2SUq8/YWxEr_Vin5I/AAAAAAAAKO4/tkq-mEXW2EQ-s_c6j5cjlP5bxRppUm3NACLcBGAsYHQ/s1024/13.jpg')})`
}}>
<div className="row bg-dark py-3 text-start text-warning rounded shadow">
  <div className="col-12 col-md-12 p-3 p-md-5 text-center">
 <StaticImage
      src="../images/logos.png"
      quality={95}
      formats={["auto", "webp", "avif"]}
      alt="Whatsapp Online Shop Order"
    />
  </div>
  <div className="col-6 col-md-2 p-3 p-md-5">
  <h3>Page</h3>
  <Link className="text-white" to="/">+ Home</Link><br/>
  <Link className="text-white" to="/fitur">+ Features</Link><br/>
  <Link className="text-white" to="/price">+ Pricing</Link><br/>
  </div>
    <div className="col-6 col-md-2 p-3 p-md-5">
  <h3>Fitur</h3>
  <Link className="text-white" to="/cms">+ CMS</Link><br/>
  <Link className="text-white" to="/shop">+ Shop</Link><br/>
  <Link className="text-white" to="/whatsapp">+ Whatsapp</Link><br/>
  <Link className="text-white" to="/qris">+ Qris</Link><br/>
  <Link className="text-white" to="/website">+ Website</Link><br/>
  </div>
    <div className="col-6 col-md-2 p-3 p-md-5">
  <h3>Bisnis</h3>
  <Link className="text-white" to="/toko">+ Toko</Link><br/>
  <Link className="text-white" to="/resto">+ Resto</Link><br/>
  </div>
    <div className="col-6 col-md-2 p-3 p-md-5">
  <h3>Contact</h3>
  <a className="text-white" href="https://wa.me/62895339403223">+ Chat Now</a><br/>
  <a className="text-white" href="tel:+62895339403223">+ Call Us</a><br/>
  <a className="text-white" href="mailto:axcora@gmail.com">+ Email</a><br/>
  <a className="text-white" href="https://goo.gl/maps/AesyjofbV3ARaH1T6">+ Maps</a>
  </div>

<div className="col-12 col-md-4 p-3 p-md-5">
<div className="ratio ratio-16x9">
<iframe src="https://www.youtube.com/embed/l6fMXa5cmbA" title="toko online shop whatsapp order" className="shadow rounded" allowfullscreen></iframe>
</div>
</div>
</div>
</div>
);
export default Boom;
